import { useContext } from 'react'

import { GameContext } from '../../App'
import { SpacedRow } from './StatusBar'
import ResourceCounter from './ResourceCounter'

function ResourceCounterList() {
    const { gameState } = useContext(GameContext)

    return (
        <SpacedRow>
            {gameState.resources.map(resource => {
               return <ResourceCounter key={resource.type} resource={resource} />
            })}
        </SpacedRow>
    )
}

export default ResourceCounterList